<div [formGroup]="paymentTermForm">
  @for (value of selectedValues; track value; let i = $index) {
<se-fe-accordion

    seFeDataTitle="{{ value.name }}"
    [seFeDataSubtitle]="
      value.payment_term_strategy.strategy_type === 'due_in_full' ? ''
      : getControlErrors(value) ? ('MULTI_PAYMENT_TERMS_SELECTOR.TITLES.error_message' | translate)
      : value.description
    "
    [seFeDataExpanded]="selectedValues.length === i + 1 && value.payment_term_strategy.strategy_type === 'custom_date'"
    seFeDataHeadingLevel="2"
    [ngClass]="getControlErrors(value) ? 'error' : ''">
    @if (i > 0) {
<se-fe-icon

      seFeAccordionHeaderActions
      (click)="removeAccordion(value)"
      seFeDataName="remove"
      seFeDataSize="500"
      seFeDataColor="gray-900"
      [seFeDataMargin]="false"></se-fe-icon>
}

    <div *seFeAccordionContent>
      <se-fe-grid seFeGridOpts="center">
        <se-fe-grid-cell seFeGridOpts="1/1@mobile 3/4@desktop">
          <se-fe-grid seFeGridOpts="snug">
            <!-- Registration Header-->
            @if (!isInvoice) {
<se-fe-grid-cell
              seFeGridOpts="1/1@mobile"
             >
              <se-fe-block
                seFeDataType="outline"
                class="se-block--condensed se-block--no-margin">
                <se-fe-grid seFeGridOpts>
                  <se-fe-grid-cell seFeGridOpts="grow@mobile">
                    <span><strong [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.upfront_payment'"></strong></span>
                    <br />
                    <small [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.due_upfront'"></small>
                  </se-fe-grid-cell>
                  <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                    <strong [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.calculated_checkout'"></strong>
                  </se-fe-grid-cell>
                </se-fe-grid>
              </se-fe-block>
            </se-fe-grid-cell>
}
            <!-- End of Registration Header-->

            <!-- Invoice Header-->
            @if (isInvoice && value.previewData?.payments && getUpFrontAmount($safeNavigationMigration(value.previewData?.payments)) !== 0) {
<se-fe-grid-cell
              seFeGridOpts="1/1@mobile"
             >
              <se-fe-block
                seFeDataType="outline"
                class="se-block--condensed se-block--no-margin">
                <se-fe-grid seFeGridOpts>
                  <se-fe-grid-cell seFeGridOpts="grow@mobile">
                    <span><strong [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.upfront_payment'"></strong></span>
                    <br />
                    <small [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.due_upfront'"></small>
                  </se-fe-grid-cell>

                  <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                    <strong>{{ getUpFrontAmount(value.previewData.payments) | currency }}</strong>
                  </se-fe-grid-cell>
                </se-fe-grid>
              </se-fe-block>
            </se-fe-grid-cell>
}
            <!-- End of Invoice Header-->

            @if (value.payment_term_strategy.strategy_type !== 'due_in_full') {
<se-fe-grid-cell
              seFeGridOpts="1/1@mobile"
             >
              <!-- Preview Percentages -->
              @if (
                  !isInvoice &&
                  value.payment_term_strategy.strategy_type !== 'custom_date' &&
                  value.payment_term_strategy.preview_percentages.length
                ) {

                <se-fe-block
                  seFeDataType="outline"
                  class="se-block--condensed se-block--no-margin">
                  @for (percentage of value.payment_term_strategy.preview_percentages; track percentage; let j = $index) {
<se-fe-grid

                    seFeGridOpts>
                    <se-fe-grid-cell seFeGridOpts="grow@mobile">
                      <strong
                        [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.installment'"
                        [translateParams]="{ index: j + 1 }"></strong>
                      <br />
                      <small>
                        @if (value.payment_term_strategy.interval) {
<span>
                          @if (j === 0) {
<span>
                            {{
                              'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.WINDOW_DUE_DATES.' +
                                value.payment_term_strategy.installment_window +
                                '_first_installment'
                                | pluralizeKey: value.payment_term_strategy.interval
                                | translate: dueDateParams(value)
                            }}
                          </span>
}
                          @if (j) {
<span>
                            {{
                              'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.WINDOW_DUE_DATES.' +
                                value.payment_term_strategy.installment_window
                                | pluralizeKey: value.payment_term_strategy.interval
                                | translate: dueDateParams(value)
                            }}
                          </span>
}
                        </span>
}
                      </small>
                    </se-fe-grid-cell>
                    <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                      <strong>{{ percentage }}%</strong>
                    </se-fe-grid-cell>
                  </se-fe-grid>
}
                </se-fe-block>

}
              <!-- End of Preview Percentages -->

              <!-- Payment Amounts-->
              @if (
                  getInstallments($safeNavigationMigration(value?.previewData?.payments)).length > 0 &&
                  isInvoice &&
                  value.payment_term_strategy.strategy_type !== 'custom_date' &&
                  value.previewData?.payments.length > 0
                ) {

                <se-fe-block
                  seFeDataType="outline"
                  class="se-block--condensed se-block--no-margin">
                  @for (payments of getInstallments(value.previewData.payments); track payments; let x = $index) {
<se-fe-grid

                    seFeGridOpts>
                    <se-fe-grid-cell seFeGridOpts="grow@mobile">
                      <strong
                        [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.installment'"
                        [translateParams]="{ index: x + 1 }"></strong>
                      <br />
                      <small>
                        <span>
                          {{ 'MULTI_PAYMENT_TERMS_SELECTOR.due' | translate }}
                          <span>{{ payments.due_date | date }}</span>
                        </span>
                      </small>
                    </se-fe-grid-cell>
                    <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                      <strong>${{ payments.amount }}</strong>
                    </se-fe-grid-cell>
                  </se-fe-grid>
}
                </se-fe-block>

}

              <!-- End of Payment Amounts-->
            </se-fe-grid-cell>
}

            <!-- Custom Dates -->
            <se-fe-grid-cell seFeGridOpts="1/1@mobile">
              @if (
                  value.payment_term_strategy.strategy_type === 'custom_date' && customDatesControl(value.id)?.controls
                ) {
<se-fe-block
                seFeDataType="outline"

                class="se-block--condensed se-block--no-margin">
                @if (!isInvoice) {

                  @for (customDate of customDatesControl(value.id)?.controls; track customDate; let k = $index) {
<se-fe-grid
                    seFeGridOpts
                    formArrayName="{{ datePrefix + value.id }}"
                   >
                    <se-fe-grid-cell
                      seFeGridOpts="grow@mobile"
                      [formGroupName]="k">
                      <strong
                        [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.installment'"
                        [translateParams]="{ index: k + 1 }"></strong>
                      <se-fe-grid
                        seFeGridOpts="baseline"
                        class="custom-date-section">
                        <se-fe-grid-cell seFeGridOpts="grow@mobile">
                          <se-fe-datepicker
                            seFeDataLabel=""
                            seFeDataHelpText="Month, day, year"
                            seFeDataDateRangeIcon="true"
                            seFeDataFormat="iso"
                            formControlName="installment"
                            [seFeDataYearRange]="{ future: 10, past: 10 }"
                            [seFeDataMessages]="getErrors(customDatesControl(value.id).controls, k)"></se-fe-datepicker>
                        </se-fe-grid-cell>
                      </se-fe-grid>
                    </se-fe-grid-cell>
                    <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                      <strong>{{ value.payment_term_strategy.preview_percentages[k] }}%</strong>
                    </se-fe-grid-cell>
                  </se-fe-grid>
}

}

                @if (isInvoice && value.previewData?.payments) {

                  @for (payments of getInstallments(value.previewData.payments); track payments; let k = $index) {
<se-fe-grid
                    seFeGridOpts
                    formArrayName="{{ datePrefix + value.id }}"
                   >
                    <se-fe-grid-cell
                      seFeGridOpts="grow@mobile"
                      [formGroupName]="k">
                      <strong
                        [translate]="'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.installment'"
                        [translateParams]="{ index: k + 1 }"></strong>
                      <se-fe-grid
                        seFeGridOpts="baseline"
                        class="custom-date-section">
                        <se-fe-grid-cell seFeGridOpts="grow@mobile">
                          <se-fe-datepicker
                            seFeDataLabel=""
                            seFeDataHelpText="Month, day, year"
                            seFeDataDateRangeIcon="true"
                            seFeDataFormat="iso"
                            formControlName="installment"
                            [seFeDataYearRange]="{ future: 10, past: 0 }"
                            [seFeDataExcludeDates]="[{ start: excludeStartDate, end: excludeEndDate }]"
                            [seFeDataMessages]="getErrors(customDatesControl(value.id).controls, k)"></se-fe-datepicker>
                        </se-fe-grid-cell>
                      </se-fe-grid>
                    </se-fe-grid-cell>
                    <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                      <strong>${{ payments.amount }}</strong>
                    </se-fe-grid-cell>
                  </se-fe-grid>
}

}
              </se-fe-block>
}
            </se-fe-grid-cell>
            <!-- End of Custom Dates -->

            <!-- Total -->
            @if (isInvoice && value.previewData) {
<se-fe-grid-cell
              seFeGridOpts="1/1@mobile"
             >
              <div>
                <se-fe-block
                  seFeDataType="outline"
                  class="se-block--condensed se-block--no-margin">
                  <se-fe-grid seFeGridOpts="snug">
                    <se-fe-grid-cell seFeGridOpts="1/2@mobile">
                      <strong>{{ 'MULTI_PAYMENT_TERMS_SELECTOR.TITLES.total' | translate }}</strong>
                    </se-fe-grid-cell>
                    <se-fe-grid-cell seFeGridOpts="1/2@mobile">
                      <se-fe-grid seFeGridOpts="right">
                        <se-fe-grid-cell seFeGridOpts="shrink@mobile">
                          <strong data-testid="payment-terms-total-amount">
                            {{ getTotalAmount(value.previewData.payments) | currency }}
                          </strong>
                        </se-fe-grid-cell>
                      </se-fe-grid>
                    </se-fe-grid-cell>
                  </se-fe-grid>
                </se-fe-block>
              </div>
            </se-fe-grid-cell>
}
            <!-- End of total -->
          </se-fe-grid>
        </se-fe-grid-cell>
      </se-fe-grid>
    </div>
  </se-fe-accordion>
}
</div>
